module.exports = __webpack_public_path__ + "static/img/icon4.a1e7f6e2.png";